module.exports = __webpack_public_path__ + "static/media/logo-header-fr-ca.493229b8.svg";